import axios from "axios";
import { isMcpAuthorizePath, logout } from "../../actions/authActions";

export const validateLogin = async () => {
    let res = await axios.get('/auth/validate_login')
    return res.data;
}


axios.interceptors.response.use(
    response => {
        return response
    },
    function (error) {
        if  (error?.response?.status === 440) {
            logout();
        }
        if (error?.response?.status === 402) {
            // ROAR-4988 (decision 4): on /mcp/authorize a pending company is reported back to the
            // MCP by the page itself (MCP_COMPANY_PENDING), so Header's background /customer 402
            // must not hijack the tab to /payment — reject instead.
            if (isMcpAuthorizePath(window.location.pathname)) {
                return Promise.reject(error)
            }
            // Company is pending checkout — every non-auth/billing route 402s server-side now.
            // Redirect straight to /payment and swallow the error so it doesn't reach the
            // calling component while the redirect is in flight. Skip the redirect if we're
            // already there — the global Header/Footer chrome around every route (including
            // /payment) still makes its own non-billing calls (e.g. customer details), which
            // would otherwise 402 on /payment itself and hard-reload the page in a loop.
            if (window.location.pathname !== '/payment') {
                window.location.href = '/payment';
            }
            return;
        }
        return Promise.reject(error)
    }
)